import { http } from 'services';

export function getIndexList(type, params, cbSuccess, cbError) {
  http.get(
    type,
    params,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function addStuffToEat(type, data, cbSuccess, cbError) {
  http.post(
    `${type}`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getDetails(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function deleteStuffToEat(type, id, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function saveDetails(type, id, data, cbSuccess, cbError) {
  http.patch(
    `${type}/${id}`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function saveStatus(type, id, data, cbSuccess, cbError) {
  http.put(
    `${type}/${id}/status`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function makeCopy(type, id, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/make-copy`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-stuff-to-eat/api-stuff-to-eat-base.js